import {
  Dropdown,
  DropdownItem,
  DropdownList,
  Input,
  Textarea
} from '@cokitchen/cokitchen-components';
import React from 'react';
import {
  BaseAddonCategoryXlsType,
  BaseAddonCategoryFormFieldType,
  BaseAddonCategoryFormType
} from 'utils/types';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow_down.svg';
import { selectionTypeList } from 'utils/constants';

const BaseAddonCategoryXlsReviewItem = ({
  addon,
  addonIndex,
  isReview,
  handleReviewClick,
  toggleAccordion,
  show,
  updateAddon
}: {
  addon: Partial<BaseAddonCategoryXlsType>;
  addonIndex: number;
  isReview: boolean;
  handleReviewClick: () => void;
  toggleAccordion: () => void;
  show: boolean;
  updateAddon: (
    i: number,
    type: BaseAddonCategoryFormType,
    e: any,
    fieldType: BaseAddonCategoryFormFieldType,
    selection_type?: string
  ) => void;
}) => {
  return (
    <div
      className={`rounded-xl border border-[#EDEDEE] w-full max-w-[698px] ${
        isReview ? 'text-gray-4' : ' text-gray-6'
      }`}>
      <div
        className='py-4 px-[20px] border-b border-b-[#EDEDEE] flex cursor-pointer justify-between items-center'
        onClick={toggleAccordion}>
        <div className='flex gap-3 items-center'>
          🍔
          <p className='text-sm'>{addon.name}</p>
        </div>
        <button
          disabled={isReview || addon?.hasError}
          className={`font-medium text-sm rounded border border-[#E7E8E9] shadow py-[6px] w-[86px] flex justify-center items-center cursor-pointer hover:bg-gray-light bg-opacity-90 first-letter:first-linemarker: ${
            addon.hasError && 'text-gray-4'
          }
          `}
          onClick={handleReviewClick}>
          {isReview ? 'Reviewed' : 'Review'}
          {addon.hasError && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
        </button>
      </div>
      {show ? (
        <div className='py-4 px-[20px]'>
          <div className='w-full mb-4'>
            <div className='flex items-center'>
              <p className='text-sm font-medium mb-1'>REF</p>
              {!addon.ref && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
            </div>
            <Input
              disabled={isReview}
              type='text'
              placeholder='Ref'
              value={addon.ref}
              onChange={(e) => updateAddon(addonIndex, 'text', e, 'ref')}
              className='text-sm'
              inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
            />
          </div>
          <div className='flex gap-6 mb-2 justify-between'>
            <div className='w-[50%]'>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Name</p>
                  {!addon.name && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  placeholder='Name'
                  type='text'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                  value={addon.name}
                  onChange={(e) => updateAddon(addonIndex, 'text', e, 'name')}
                  className='text-sm'
                />
              </div>
            </div>
            <div className='w-[50%]'>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Description</p>
                  {!addon.description && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  type='text'
                  placeholder='Description'
                  value={addon.description}
                  onChange={(e) => updateAddon(addonIndex, 'text', e, 'description')}
                  className='text-sm'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                />
              </div>
            </div>
          </div>
          <div className='flex gap-6 mb-2 justify-between'>
            <div className='w-[50%]'>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Min Selection</p>
                  {!addon.min_selection && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  placeholder='Min Selection'
                  type='tel'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                  value={addon.min_selection}
                  onChange={(e) => updateAddon(addonIndex, 'text', e, 'min_selection')}
                  className='text-sm'
                />
              </div>
            </div>
            <div className='w-[50%]'>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Max Selection</p>
                  {!addon.max_selection && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  type='tel'
                  placeholder='Max Selection'
                  value={addon.max_selection}
                  onChange={(e) => updateAddon(addonIndex, 'text', e, 'max_selection')}
                  className='text-sm'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                />
              </div>
            </div>
          </div>
          <div className='w-full mb-7'>
            <div className='flex items-center'>
              <p className='text-sm font-medium mb-1'>Selection Type</p>
              {!addon.selection_type && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
            </div>

            <Dropdown
              content={
                <div className='w-full rounded border border-[#E6E5E5] py-[14px] pl-[20px] pr-[14px] flex justify-between items-center h-[50px]'>
                  <p className='text-sm'>
                    {addon.selection_type?.replaceAll('_', ' ') || 'No type selected'}
                  </p>
                  <ArrowDownIcon />
                </div>
              }>
              <DropdownList className={`${isReview ? 'hidden' : 'block'}`}>
                {selectionTypeList.map((type, i) => (
                  <DropdownItem
                    key={i}
                    onClick={() =>
                      updateAddon(addonIndex, 'dropdown', null, 'selection_type', type.value)
                    }>
                    {type.text}
                  </DropdownItem>
                ))}
              </DropdownList>
            </Dropdown>
          </div>
          <Textarea
            disabled={isReview}
            label='Subtitle'
            className='border-gray-1 text-sm'
            placeholder='Subtitle'
            value={addon.subtitle || ''}
            onChange={(e) => updateAddon(addonIndex, 'text', e, 'subtitle')}
            rows={3}
          />
        </div>
      ) : null}
    </div>
  );
};

export default BaseAddonCategoryXlsReviewItem;
